import config from "@/config";
import { useFrontChatBoot } from "front-chat-sdk/hooks";
import { useEffect } from "react";
import { useAuth } from "@babackapp/auth-client/hooks";
import { useFrontChatHash } from "@babackapp/private-api-client/client/use-frontchat-hash";

export function FrontChat() {
  const { initialize, isInitialized } = useFrontChatBoot(document.body);
  const { user } = useAuth();
  const frontChatHashQuery = useFrontChatHash();

  useEffect(() => {
    if (
      !config.isProd ||
      !initialize ||
      isInitialized ||
      !user ||
      frontChatHashQuery.isLoading
    ) {
      return;
    }

    initialize({
      chatId: config.frontchatId,
      userHash: frontChatHashQuery.data?.frontHash,
      useDefaultLauncher: true,
      email: user.emails[0]?.address,
      name: `${user.profile?.firstName || ""} ${user.profile?.lastName || ""}`.trim(),
    });
  }, [
    isInitialized,
    initialize,
    frontChatHashQuery.isLoading,
    config.frontchatId,
  ]);

  return <></>;
}
